module.exports = __webpack_public_path__ + "static/media/mapa02.1fe34504.png";